import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface TagSearchContextType {
    isOpen: boolean;
    openTagSearch: () => void;
    closeTagSearch: () => void;
    relatedTags: string[];
    setRelatedTags: (tags: string[]) => void;
}

const TagSearchContext = createContext<TagSearchContextType | null>(null);

export const useTagSearch = () => {
    const context = useContext(TagSearchContext);
    if (!context) {
        throw new Error('useTagSearch must be used within a TagSearchProvider');
    }
    return context;
};

export const TagSearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [relatedTags, setRelatedTags] = useState<string[]>([]);

    const openTagSearch = useCallback(() => setIsOpen(true), []);
    const closeTagSearch = useCallback(() => setIsOpen(false), []);

    return (
        <TagSearchContext.Provider value={{ isOpen, openTagSearch, closeTagSearch, relatedTags, setRelatedTags }}>
            {children}
        </TagSearchContext.Provider>
    );
};
